import React from 'react';
import LayoutBlank from './layout-blank';
import HomeLayout from './home-layout';

type AppLayoutSelectorProps = {
  children: React.ReactNode;
  pageProps: any;
};

const LayoutSelector = ({ children, pageProps }: AppLayoutSelectorProps) => {
  return pageProps?.pageLayout === 'blank' ? (
    <LayoutBlank>{children}</LayoutBlank>
  ) : (
    <HomeLayout footerDisclaimerConfig={pageProps?.footerDisclaimerConfig}>
      {children}
    </HomeLayout>
  );
};

export default LayoutSelector;
